document.addEventListener('DOMContentLoaded', function() {
  // ← Your pincode→days map is right here:
  const deliveryMap = {
    "110001": 2,
    "110002": 3,
    "400001": 5,
    "560001": 4
    // …add every pincode you serve
  };

  const btn   = document.getElementById('check');
  const input = document.getElementById('pin');
  const msg   = document.getElementById('delivery-msg');
  if (!btn || !input || !msg) return;  // safety

  btn.addEventListener('click', function(){
    const pin = input.value.trim();
    if (!/^\d{6}$/.test(pin)) {
      return msg.textContent = '⚠️ Enter a valid 6-digit pincode.';
    }
    const days = deliveryMap[pin];
    if (days != null) {
      msg.textContent = `✅ Expected delivery in ${days} day${days>1?'s':''}.`;
    } else {
      msg.textContent = '❌ We do not ship to your pincode yet.';
    }
  });
});
